export default {
    top_menu: [
        {name:'Главное',    id:0},
        {name:'Шоу-Бизнес', id:1},
        {name:'Кулинария',  id:2},
        {name:'Политика',   id:3},
        {name:'Пикантное',  id:4},
        {name:'Общество',   id:5},
        {name:'Здоровье',   id:6},
    ],
    read_other: 'Читать далее',
    read_more:  'Подробнее',
    not_found:  'Ничего не найдено',
    read_also:  'Читайте также',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Все права защищены.',
    subscribe: 'Подписаться',

    thank_order: 'СПАСИБО ЗА ЗАКАЗ',
    specialist_contact: 'Наш специалист скоро свяжется с вами, ожидайте нашего звонка.',
    attention: 'Скидки от партнеров:',
    hurry: 'Торопитесь, время активации скидки ограничено! У вас есть всего <span id="time" class="time">30:00</span> минут, чтобы выбрать один из этих уникальных товаров:',

    hour_ago1: "час назад",
    hour_ago2: "часа назад",
    hour_ago3: "часов назад",
    new_publications: "Новые публикации",
    read: "Читать",
    today_at: "Сегодня в",
    author_names: ['Елена Климова','Мария Андреева','Ирина Клименко'],
    main_news: "Главные новости",
    leave_already: "Уже уходите? Подождите, мы обновили для Вас новости",
    already_shared: "уже поделились"

}